import { takeLatest, put, call } from "redux-saga/effects";
import {
  GET_ANOMALIES_SERVICE_REQUEST,
  GET_ANOMALIES_SERVICE_SUCCESS,
  GET_ANOMALIES_SERVICE_FAILURE,
  GET_ANOMALY_BY_ID_SERVICE_REQUEST,
  GET_ANOMALY_BY_ID_SERVICE_SUCCESS,
  GET_ANOMALY_BY_ID_SERVICE_FAILURE,
  UPDATE_ANOMALY_STATUS_SERVICE_REQUEST,
  UPDATE_ANOMALY_STATUS_SERVICE_SUCCESS,
  UPDATE_ANOMALY_STATUS_SERVICE_FAILURE,
  UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST,
  UPDATE_ANOMALY_LEVEL_SERVICE_SUCCESS,
  UPDATE_ANOMALY_LEVEL_SERVICE_FAILURE,
  DELETE_ANOMALY_SERVICE_REQUEST,
  DELETE_ANOMALY_SERVICE_SUCCESS,
  DELETE_ANOMALY_SERVICE_FAILURE,
} from "./actions";
import {
  getAnomalies,
  getAnomalyById,
  updateAnomalyStatus,
  updateAnomalyLevel,
  deleteAnomaly,
} from "../../api/anomaly";

// Anomali listesi
function* getAnomaliesSaga() {
  try {
    const response = yield call(getAnomalies);
    console.log("Saga Response:", response); // Saga yanıtını kontrol etmek için
    if (response && response.data && response.data.body && response.data.body.result) {
      yield put({
        type: GET_ANOMALIES_SERVICE_SUCCESS,
        payload: response.data.body.result,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error); // Hata detaylarını görmek için
    yield put({
      type: GET_ANOMALIES_SERVICE_FAILURE,
      payload: error.message || "Veri alınamadı",
    });
  }
}

// Tek bir anomali getirme
function* getAnomalyByIdSaga(action) {
  try {
    const response = yield call(getAnomalyById, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: GET_ANOMALY_BY_ID_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: GET_ANOMALY_BY_ID_SERVICE_FAILURE,
      payload: error.message || "Veri alınamadı",
    });
  }
}

// Anomali durumu güncelleme
function* updateAnomalyStatusSaga(action) {
  try {
    const response = yield call(updateAnomalyStatus, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: UPDATE_ANOMALY_STATUS_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: UPDATE_ANOMALY_STATUS_SERVICE_FAILURE,
      payload: error.message || "Güncelleme başarısız",
    });
  }
}

// Anomali seviyesi güncelleme
function* updateAnomalyLevelSaga(action) {
  try {
    const response = yield call(updateAnomalyLevel, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: UPDATE_ANOMALY_LEVEL_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: UPDATE_ANOMALY_LEVEL_SERVICE_FAILURE,
      payload: error.message || "Güncelleme başarısız",
    });
  }
}

// Anomali silme
function* deleteAnomalySaga(action) {
  try {
    const response = yield call(deleteAnomaly, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: DELETE_ANOMALY_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: DELETE_ANOMALY_SERVICE_FAILURE,
      payload: error.message || "Silme işlemi başarısız",
    });
  }
}

export default function* anomalySaga() {
  yield takeLatest(GET_ANOMALIES_SERVICE_REQUEST, getAnomaliesSaga);
  yield takeLatest(GET_ANOMALY_BY_ID_SERVICE_REQUEST, getAnomalyByIdSaga);
  yield takeLatest(UPDATE_ANOMALY_STATUS_SERVICE_REQUEST, updateAnomalyStatusSaga);
  yield takeLatest(UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST, updateAnomalyLevelSaga);
  yield takeLatest(DELETE_ANOMALY_SERVICE_REQUEST, deleteAnomalySaga);
} 